<div class="help-box">
    <div class="help-left">
        <div class="help-title">{{ translate.currentLang === 'en' ? 'Having trouble?' : 'সমস্যা হচ্ছে?' }}</div>

    </div>
    <div class="help-right">
        <a [href]="'tel:' + supportPhone" class="help-contact">
            <i class="fas fa-phone"></i>
            <span>{{ supportPhone }}</span>
        </a>
    </div>
</div>